export enum QuoteStatus {
  New = '1',
  AwaitingApproval = '2',
  AskedForChanges = '3',
  Revised = '4',
  Approved = '5',
  Declined = '6',
  SOCreated = '7',
  Canceled = '8',
  AwaitingResponse = '9'
}

export function awaitsCustomerAction(statusId: string | number | null | undefined): boolean {
  const id = String(statusId);
  return id === QuoteStatus.AwaitingApproval || id === QuoteStatus.AwaitingResponse;
}
